import { product } from '../services/product';

export const receiveProducts = (products) => ({
  type: 'PRODUCTS_SUCCESS',
  products,
});

export const requestProductsError = (error) => ({
  type: 'PRODUCTS_FAILURE',
  error,
});

export const fetchProductsOfClient = () =>
  function (dispatch) {
    dispatch({
      type: 'PRODUCTS_REQUEST',
    });
    return product.getProductsOfClient();
  };

export const updateIsSynchronizingCashierProductsStatus = (isSynchronizingCashierProducts) => ({
  type: 'IS_SYNCHRONIZING_CASHIER_PRODUCTS_UPDATE',
  isSynchronizingCashierProducts,
});
